export const TOGGLE_MODAL = 'cart/TOGGLE_MODAL'
export const OPEN_MODAL = 'cart/OPEN_MODAL'
export const CLOSE_MODAL = 'cart/CLOSE_MODAL'
export const ADD_EDIT_PRODUCT = 'cart/ADD_EDIT_PRODUCT'
export const ADD_GROUP_ITEM = 'cart/ADD_GROUP_ITEM'
export const REMOVE_PRODUCT = 'cart/REMOVE_PRODUCT'
export const SET_GROUP_ITEM_VALUE = 'cart/SET_GROUP_ITEM_VALUE'
export const SET_GROUP_ITEM_QNT = 'cart/SET_GROUP_ITEM_QNT'
export const SET_VALUE_PRODUCT = 'cart/SET_VALUE_PRODUCT'
export const SET_QNT_PRODUCT = 'cart/SET_QNT_PRODUCT'
export const SET_COMPANY_DOCUMENT = 'cart/SET_COMPANY_DOCUMENT'
export const SET_CART_DATA = 'cart/SET_CART_DATA'
export const SET_SPOKESMAN = 'cart/SET_SPOKESMAN'
export const SET_SPOKESMEN_DATA = 'cart/SET_SPOKESMEN_DATA'
export const SET_COMPANY_ADDRESSES = 'cart/SET_COMPANY_ADDRESSES'
export const START_POSTAL_CODE_SEARCH = 'cart/START_POSTAL_CODE_SEARCH'
export const SET_POSTAL_CODE_ERROR = 'cart/SET_POSTAL_CODE_ERROR'
export const SET_PAT = 'cart/SET_PAT'
export const SET_FEE = 'cart/SET_FEE'
export const CLOSE_UP_SELL_FEE = 'cart/CLOSE_UP_SELL_FEE'
export const SET_UP_SELL_FEE_TARGET = 'cart/SET_UP_SELL_FEE_TARGET'
export const SET_POD_TUDO_FEE = 'cart/SET_POD_TUDO_FEE'
export const SET_TOTAL_FEE = 'cart/SET_TOTAL_FEE'
export const SET_FEE_ERROR = 'cart/SET_FEE_ERROR'
export const CLEAR_CART = 'cart/CLEAR_CART'
export const SET_COMPANY_DATA = 'cart/SET_COMPANY_DATA'
export const SET_COMPANY_NAME = 'cart/SET_COMPANY_NAME'
export const CLEAR_NEW_PRODUCT = 'cart/CLEAR_NEW_PRODUCT'
export const ADD_NEW_PRODUCT = 'cart/ADD_NEW_PRODUCT'
export const CHANGE_PAYMENT_TYPE = 'cart/CHANGE_PAYMENT_TYPE'
export const SET_CONTRACT_DATA = 'cart/SET_CONTRACT_DATA'
export const SET_CONTRACTS = 'cart/SET_CONTRACTS'
export const SET_SPOKESMAN_DOCUMENT = 'cart/SET_SPOKESMAN_DOCUMENT'
export const SET_DOCUMENT_VERIFICATION = 'cart/SET_DOCUMENT_VERIFICATION'
export const CLOSE_PRIVACITY_TERMS = 'cart/CLOSE_PRIVACITY_TERMS'
export const ACCEPT_PRIVACITY_TERMS = 'cart/ACCEPT_PRIVACITY_TERMS'
export const RECOVERY_CART = 'cart/RECOVERY_CART'
export const RESET = 'cart/RESET'
export const SET_RECOVERY_CART = 'cart/SET_RECOVERY_CART'
export const RESET_SPOKESMAN = 'cart/RESET_SPOKESMAN'
export const FILL_BUREAU_DATA = 'cart/FILL_BUREAU_DATA'
export const FILL_CART_PRODUCT = 'cart/FILL_CART_PRODUCT'
